import React, { useState } from 'react';
import {
  TextField,
  Box,
  MenuItem,
  Select,
  FormControl,
  InputAdornment,
  Typography,
} from '@mui/material';
import { countryCodes } from '../utils/phoneUtils';

const CountryCodeSelector = ({ 
  phoneValue, 
  countryCodeValue, 
  onPhoneChange, 
  onCountryCodeChange, 
  error, 
  helperText 
}) => {
  const [selectedCountry, setSelectedCountry] = useState(
    countryCodes.find(country => country.code === countryCodeValue) || countryCodes.find(country => country.code === '+91')
  );

  const handleCountryChange = (event) => {
    const countryCode = event.target.value;
    const country = countryCodes.find(c => c.code === countryCode);
    setSelectedCountry(country);
    onCountryCodeChange(countryCode);
  };

  const handlePhoneChange = (event) => {
    const phoneNumber = event.target.value;
    onPhoneChange(phoneNumber);
  };

  return (
    <TextField
      fullWidth
      label="Phone Number"
      value={phoneValue}
      onChange={handlePhoneChange}
      error={error}
      helperText={helperText}
      placeholder="98765 43210"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <FormControl 
              size="small"
              sx={{ 
                minWidth: 80,
                '& .MuiOutlinedInput-root': {
                  borderRadius: 1,
                  '& fieldset': {
                    border: 'none',
                  },
                  '&:hover fieldset': {
                    border: 'none',
                  },
                  '&.Mui-focused fieldset': {
                    border: 'none',
                  },
                },
              }}
            >
              <Select
                value={countryCodeValue}
                onChange={handleCountryChange}
                size="small"
                sx={{
                  '& .MuiSelect-select': {
                    display: 'flex',
                    alignItems: 'center',
                    padding: '4px 8px',
                    fontSize: '0.875rem',
                    fontWeight: 500,
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: 300,
                      '& .MuiMenuItem-root': {
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        py: 1,
                        px: 2,
                      },
                    },
                  },
                }}
              >
                {countryCodes.map((country) => (
                  <MenuItem key={country.code} value={country.code}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <span style={{ fontSize: '1rem' }}>{country.flag}</span>
                      <Typography sx={{ fontWeight: 500, fontSize: '0.875rem' }}>
                        {country.code}
                      </Typography>
                    </Box>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </InputAdornment>
        ),
      }}
      sx={{
        '& .MuiOutlinedInput-root': {
          borderRadius: 2,
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'primary.main',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'primary.main',
            borderWidth: 2,
          },
        },
      }}
    />
  );
};

export default CountryCodeSelector;
